import SvgIcon from '../svg/SvgIcon'

const LOADER_SIZE = 50

export default props => {
  const { available, muted, loaded, onClick, svgIcons } = props
  const soundOnOff = available && !muted && loaded ? 'on' : 'off'

  return (
    <div className="sound-button" >
      <SvgIcon
        svgIcons={svgIcons}
        iconName={`sound-${soundOnOff}`}
        onClick={onClick}
        eventsOnContainer={true}
      />
      {available && !loaded && renderLoader(props)}
    </div>
  )
}

const renderLoader = props => {
  const { loading } = props
  const loaderProps = {
    className: `soundLoading ${loading ? 'visible' : ''}`,
    width: LOADER_SIZE * 1.6,
    height: LOADER_SIZE * 1.6
  }

  const circleProps = {
    cx: LOADER_SIZE * 0.84,
    cy: LOADER_SIZE * 0.84,
    r: LOADER_SIZE * 0.44
  }

  return (
    <svg {...loaderProps}>
      <circle {...circleProps} />
    </svg>
  )
}
